import { render, staticRenderFns } from "./PricingItemsInfo.vue?vue&type=template&id=21f26fb8&"
import script from "./PricingItemsInfo.vue?vue&type=script&lang=js&"
export * from "./PricingItemsInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports